import { Box, Drawer, Typography } from '@mui/material';
import { FC, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CloseIcon } from 'src/assets/svg/close-icon.svg';

import { styles } from './styles';
import { AgreementDrawerProps } from './types';

export const AgreementDrawer: FC<AgreementDrawerProps> = ({
    open,
    closeFn,
    currentAgreement,
    totalAgreements,
    children,
}) => {
    const { t } = useTranslation();
    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (contentRef.current) {
            contentRef.current.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
    }, [currentAgreement]);

    const handleIconClick = () => {
        closeFn();
    };

    return (
        <Drawer anchor="bottom" open={open} css={styles.agreementDrawer} onClose={closeFn}>
            <Box css={styles.header}>
                <Typography variant="h4">
                    {t('agreement_drawer_title', {
                        number: currentAgreement,
                        total: totalAgreements,
                    })}
                </Typography>
                <CloseIcon css={styles.closeIcon} onClick={handleIconClick} />
            </Box>

            <Box css={styles.content} ref={contentRef}>
                {children}
            </Box>
        </Drawer>
    );
};
